import '../../../assets/styles/components/_loader.scss'
import { useTranslation } from 'react-i18next';

type IProps = {
  className?: string
}

const Loader = ({className}: IProps): JSX.Element => {
  const {t} = useTranslation();
  return (
    <div className={className ?? "loader"}>{t('common.loading')}</div>
  );
}

export default Loader;
